import axios from "axios";
const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV2 = process.env.VUE_APP_API_V2;

class AdvertiserService {
  showBikes(id) {
     return axios.get(`${baseUrl + apiV2}/advertiser/${id}`)
  }
}

export default new AdvertiserService();
